import { render } from "./PageProgressBar.vue?vue&type=template&id=9142a2ca&scoped=true&bindings={\"value\":\"props\"}"
import script from "./PageProgressBar.vue?vue&type=script&lang=js"
export * from "./PageProgressBar.vue?vue&type=script&lang=js"

import "./PageProgressBar.vue?vue&type=style&index=0&id=9142a2ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9142a2ca"

export default script